import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FiX, FiMenu } from "react-icons/fi";

import logoDefault from "../../assets/images/logo/logo.png";
import logoLight from "../../assets/images/logo/logo-light.png";
import logoDark from "../../assets/images/logo/logo-dark.png";
import logoSymbolDark from "../../assets/images/logo/logo-symbol-dark.png";
import logoSymbolLight from "../../assets/images/logo/logo-symbol-light.png";

class Header extends Component {
  constructor(props) {
    super(props);
    this.menuTrigger = this.menuTrigger.bind(this);
    this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
    //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
    window.addEventListener("load", function () {
      console.log("All assets are loaded");
    });
  }

  menuTrigger() {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  }

  CLoseMenuTrigger() {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  }

  render() {
    var elements = document.querySelectorAll(".has-droupdown > a");
    for (var i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].onclick = function () {
          this.parentElement
            .querySelector(".submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
    const { logo, color = "default-color" } = this.props;
    let logoUrl;
    if (logo === "light") {
      logoUrl = <img src={logoLight} alt="logo_abyba" />;
    } else if (logo === "dark") {
      logoUrl = <img src={logoDark} alt="logo_abyba" />;
    } else if (logo === "symbol-dark") {
      logoUrl = <img src={logoSymbolDark} alt="logo_abyba" />;
    } else if (logo === "symbol-light") {
      logoUrl = <img src={logoSymbolLight} alt="logo_abyba" />;
    } else {
      logoUrl = <img src={logoDefault} alt="logo_abyba" />;
    }

    return (
      <header
        className={`header-area formobile-menu header--transparent ${color}`}
      >
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">{logoUrl}</a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <ul className="mainmenu">

                <li>
                  <Link to="/about">Nosotros</Link>
                </li>

                <li className="has-droupdown">
                  <Link to="/service">Servicios</Link>
                  <ul className="submenu">
                    <li>
                      <Link to="/details-service-1">Jurídico y contable</Link>
                    </li>
                    <li>
                      <Link to="/details-service-2">E-commerce consulting</Link>
                    </li>
                    <li>
                      <Link to="/details-service-3">Estrategias financieras</Link>
                    </li>
                    <li>
                      <Link to="/details-service-4">Real estate</Link>
                    </li>
                    <li>
                      <Link to="/details-service-5">Diseño, IA y social media</Link>
                    </li>
                    <li>
                      <Link to="/details-service-6">Gestion de talento</Link>
                    </li>
                  </ul>
                </li>

                <li className="has-droupdown">
                  <Link to="/solutions">Soluciones</Link>
                  <ul className="submenu">
                    <li>
                      <Link to="/plan-senior">Plan Senior</Link>
                    </li>
                    <li>
                      <Link to="/plan-ejecutive">Plan Ejecutive</Link>
                    </li>
                    <li>
                      <Link to="/plan-advanced">Plan Advanced</Link>
                    </li>
                    <li>
                      <Link to="/plan-expert">Plan Expert</Link>
                    </li>
                    <li>
                      <Link to="/plan-management">Plan management</Link>
                    </li>
                  </ul>
                </li>

                <li>
                  <Link to="/start-in-usa">Emprende en USA</Link>
                </li>

                <li>
                  <Link to="/club-senior">Club Senior</Link>
                </li>

                <li>
                  <Link to="/contact">Contacto</Link>
                </li>
              </ul>
            </nav>

            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span
                onClick={this.menuTrigger}
                className="menutrigger text-white"
              >
                <FiMenu />
              </span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={this.CLoseMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default Header;
